module.exports = __webpack_public_path__ + "static/media/button_shoe1d4af341f05d548b18fd93a798de714.webp";